import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeCommission } from 'bundles/apex/deals/form/store/deal/actions';

import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';
import Tooltip from 'components/tooltip';

const disabledMessage = 'Can be edited on the voucher';
const unitOptions = {
  gross_unit_dollars: '$',
  gross_unit_percent: '%',
};

// TODO: Standardize enums across classes
const transactionSideUnitOptions = {
  unit_dollars: '$',
  unit_percent: '%',
};

export function BrokerGrossCommissionInputs({ changeCommission, commission, deal, transactionSide }) {
  let dataSource;
  if (transactionSide) {
    dataSource = commission.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  } else {
    dataSource = commission;
  }

  const isPercent = dataSource.grossUnit.endsWith('unit_percent');
  const valueName = isPercent ? 'grossPercent' : 'grossAmount';

  function handleChange(changes) {
    changeCommission(commission, changes, transactionSide);
  }

  let valueInput = (
    <ManagedInput
      className="form-control value"
      disabled={!!deal.voucher}
      name={valueName}
      type={isPercent ? 'number' : 'currency'}
      value={dataSource[valueName]}
      onChange={handleChange}
    />
  );

  if (deal.voucher) {
    valueInput = <Tooltip content={disabledMessage}>{valueInput}</Tooltip>;
  }

  return <React.Fragment>
    <ManagedInput
      className="form-control units"
      disabled={!!deal.voucher}
      name="grossUnit"
      type="select"
      value={dataSource.grossUnit}
      onChange={handleChange}
    >
      <Options options={transactionSide ? transactionSideUnitOptions : unitOptions} />
    </ManagedInput>

    {valueInput}
  </React.Fragment>;
}

BrokerGrossCommissionInputs.propTypes = {
  changeCommission: PropTypes.func.isRequired,
  commission: PropTypes.shape({
    grossAmount: PropTypes.number,
    grossPercent: PropTypes.number,
    grossUnit: PropTypes.oneOf(Object.keys(unitOptions)).isRequired,
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number,
      grossPercent: PropTypes.number,
      grossUnit: PropTypes.oneOf(Object.keys(transactionSideUnitOptions)).isRequired,
    })),
  }).isRequired,
  deal: PropTypes.shape({
    voucher: PropTypes.object,
  }).isRequired,
  transactionSide: PropTypes.string,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  changeCommission,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerGrossCommissionInputs);
